interface Props {
    children?: React.ReactNode;
}

export const ApplicationLayoutContent = ({
    children,
}: Props): React.ReactElement<any, any> | null => {
    return <div className="layout-main-content">{children}</div>;
};
